import {useMonthlyReview} from '../../hooks/useMonthlyReview'
import {MonthlyReviewModal} from './_reviewModal'
import {MonthlyReviewThankYouModal} from './_thankYouModal'

// Popup đánh giá trải nghiệm định kỳ hàng tháng - chỉ áp dụng cho trang Tổng quan
export const MonthlyReview = ({disabled = false}) => {
  const {data, functions} = useMonthlyReview()

  return (
    <>
      {!disabled && data.open && (
        <MonthlyReviewModal
          content={data.content}
          loading={data.loading}
          month={data.month}
          star={data.star}
          onChangeContent={functions.handleChangeContent}
          onChangeStar={functions.handleChangeStar}
          onClose={functions.handleClose}
          onSkip={functions.handleSkip}
          onSubmit={functions.handleSubmit}
        />
      )}
      {data.openThankYou && (
        <MonthlyReviewThankYouModal onClose={functions.handleCloseThankYou} />
      )}
    </>
  )
}

export default MonthlyReview
